import store from "@/store";
import professoresService from "@/Services/ProfessoresService";

const GESTOES_CACHE_KEY = "gestoes_cache";

function getCacheKey() {
  const user = store.getters["Auth/user"];
  if (!user) return null;
  return `${GESTOES_CACHE_KEY}_${user.id}_${user.configuracao_id}`;
}

function getGestoesFromCache() {
  const key = getCacheKey();
  if (!key) return null;

  try {
    const cached = localStorage.getItem(key);
    if (cached) {
      return JSON.parse(cached);
    }
  } catch (error) {
    // eslint-disable-next-line
    console.error("Erro ao ler cache de gestões:", error);
  }
  return null;
}

function setGestoesCache(data) {
  const key = getCacheKey();
  if (!key) return;

  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    // eslint-disable-next-line
    console.error("Erro ao salvar cache de gestões:", error);
  }
}

async function checkUserTemGestao(tipo = "regular") {
  const user = store.getters["Auth/user"];

  if (!user) return false;

  if (user.roleName !== "professor" && user.roleName !== "prof-auxiliar") return true;

  const cachedData = getGestoesFromCache();
  if (cachedData) {
    return tipo === "regular"
      ? cachedData.qtd_gestoes_regulares > 0
      : cachedData.qtd_gestoes_auxiliares > 0;
  }

  try {
    const response = await professoresService.listarGestoesDoUsuario(user.id);
    setGestoesCache(response);

    return tipo === "regular"
      ? response?.qtd_gestoes_regulares > 0
      : response?.qtd_gestoes_auxiliares > 0;
  } catch (error) {
    console.error(error);
    return false;
  }
}

function checkGestaoGuard(tipo = "regular") {
  return async (_to, _from, next) => {
    const temGestao = await checkUserTemGestao(tipo);
    if (!temGestao) return next({ name: "NaoAutorizado" });
    return next();
  };
}

function limparCacheGestoes() {
  try {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(GESTOES_CACHE_KEY)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    // eslint-disable-next-line
    console.error("Erro ao limpar cache de gestões:", error);
  }
}

export { checkUserTemGestao, checkGestaoGuard, limparCacheGestoes };

export default (vue) => {
  vue.prototype.$checkUserTemGestao = checkUserTemGestao;
  vue.prototype.$limparCacheGestoes = limparCacheGestoes;
};
